import { useToastStore } from '../../lib/toast';
import {
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastIcon,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './toast';

/**
 * App-level toast renderer. Mount once near the root (after providers).
 *
 *   <Toaster />
 *
 * Fire toasts from anywhere via `toast(...)` (`src/lib/toast.ts`).
 */
export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <ToastProvider swipeDirection="right">
      {toasts.map((t) => {
        const durationMs = t.duration === 'infinite' ? Infinity : t.duration;
        const liveness: 'polite' | 'assertive' =
          t.tone === 'warning' || t.tone === 'danger' ? 'assertive' : 'polite';
        return (
          <Toast
            key={t.id}
            tone={t.tone}
            duration={durationMs}
            type={liveness === 'assertive' ? 'foreground' : 'background'}
            onOpenChange={(open) => {
              if (!open) dismiss(t.id);
            }}
          >
            <ToastIcon tone={t.tone} />
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <ToastTitle>{t.title}</ToastTitle>
              {t.description && <ToastDescription>{t.description}</ToastDescription>}
              {t.action && (
                <ToastAction
                  altText={t.action.label}
                  onClick={() => {
                    t.action!.onClick();
                    dismiss(t.id);
                  }}
                >
                  {t.action.label}
                </ToastAction>
              )}
            </div>
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
